export const getPageIdFromNotionUrl = (notionUrl: string) => {
  // The page ID is the number after the base URL
  const [pageId] = (notionUrl?.split('https://www.notion.so/') ?? []).reverse()

  return pageId
}
